import { useState } from 'react'
import { Modal, Input, Form, Message } from '@arco-design/web-react'
import { batchSetChannelTagApi } from '@/api/channels'

interface Props {
  visible: boolean
  ids: number[]
  onCancel: () => void
  onSuccess?: () => void
}

export default function BatchTagModal({ visible, ids, onCancel, onSuccess }: Props) {
  const [tag, setTag] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async () => {
    if (!ids.length) {
      Message.warning('请先选择要操作的渠道')
      return
    }
    setLoading(true)
    try {
      const n = await batchSetChannelTagApi(ids, tag.trim())
      Message.success(`已为 ${n} 个渠道设置标签`)
      setTag('')
      onSuccess?.()
      onCancel()
    } catch (err: unknown) {
      Message.error(err instanceof Error ? err.message : '操作失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={`批量设置标签（已选 ${ids.length} 项）`}
      visible={visible}
      onCancel={onCancel}
      onOk={submit}
      confirmLoading={loading}
      okText="保存"
    >
      <Form layout="vertical">
        <Form.Item label="标签名" extra="留空表示清除标签。同一标签的渠道会在渠道页按标签聚合展示。">
          <Input value={tag} onChange={setTag} placeholder="例如：official / backup / test" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
